import { CaseQuery } from 'dashboard/models/case-query';
import { CaseQueriesActions, CaseQueriesActionType } from 'dashboard/redux/actions/case-queries';

export interface CaseQueriesState {
  caseQueries: CaseQuery[];
}

const initialCaseQueriesState: CaseQueriesState = {
  caseQueries: [],
};

export default (state: CaseQueriesState = initialCaseQueriesState, action: CaseQueriesActions) => {
  switch (action.type) {
    case CaseQueriesActionType.SetCaseQueries: {
      return {
        ...state,
        caseQueries: action.payload.caseQueries,
      };
    }

    default:
      return state;
  }
};
